export default "__VITE_ASSET__1c987d30__$_?react__"